import axios, { AxiosInstance } from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Reads flash's auth token. useLocalStorage stores values JSON-stringified,
 * so the raw localStorage value is a quoted string we must parse.
 */
function getToken(): string | null {
	try {
		const raw = window.localStorage.getItem('token');
		if (!raw) return null;
		return JSON.parse(raw) as string;
	} catch {
		return null;
	}
}

export const client: AxiosInstance = axios.create({
	baseURL: BASE_URL,
	headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
	const token = getToken();
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	config.headers.deviceType = 'WEB';
	return config;
});

/**
 * Normalizes batman's two response shapes:
 *  - enveloped: { data, statusCode, msg } -> returns data
 *  - un-enveloped (e.g. /patient/list)    -> returns the body as-is
 */
export function unwrap<T = any>(body: any): T {
	if (
		body &&
		typeof body === 'object' &&
		'data' in body &&
		'statusCode' in body
	) {
		return body.data as T;
	}
	return body as T;
}
